<template>
  <div class="container col-10">
    <div class="headerReport">
      <div v-if="this.loading" class="text-center">
        <v-progress-circular
          class="mt-auto"
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <v-data-table
        v-else
        :headers="headers"
        :items="ListConfirmMonetization.reports"
        :header-props="{ class: 'red-header' }"
        :search="searchTerm"
        :no-data-text="$t('chart.label.notData') || 'No hay datos disponibles'"
        :footer-props="{ 'items-per-page-text': $t('label.rowsPerPage.title') }"
      >
        <!-- Sección superior de la tabla -->
        <template v-slot:top>
          <div style="margin-bottom: 50px; margin-left: 50px">
            <div class="row justify-space-between mx-auto">
              <v-text-field
                :label="$t('label.search.title')"
                :placeholder="$t('label.search.text')"
                append-icon="mdi-magnify"
                dense
                outlined
                class="col-md-5"
                @input="search"
              ></v-text-field>
            </div>
          </div>
        </template>

        <template v-slot:[`item.monetizationReportId`]="{ item }">
          <span class="custom-font">{{ item.monetizationReportId }}</span>
        </template>

        <template v-slot:[`item.startDate`]="{ item }">
          <span class="custom-font">{{ item.startDate }}</span>
        </template>

        <template v-slot:[`item.requestCount`]="{ item }">
          <span class="custom-font">{{ item.requestCount }}</span>
        </template>

        <template v-slot:[`item.requestStatus`]="{ item }">
          <span class="custom-font">{{ item.requestStatus }}</span>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-icon color="primary" size="x-large"></v-icon>

          <div class="actions">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  x-large
                  dark
                  text
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  @click="redirectToDownload(item.fileLink)"
                  style="background-color: transparent; margin-left: 1vh"
                >
                  <v-icon color="primary">mdi-download</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('button.download') }}</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  x-large
                  dark
                  text
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  :disabled="item.requestStatus != 'Pendiente'"
                  @click="modelConfirmMonetization(item.monetizationReportId)"
                  style="background-color: transparent; margin-left: 1vh"
                >
                  <v-icon color="primary">mdi-upload</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('button.uploadFile') }}</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <div class="totalSolicitudesContainer">
        <p class="totalSolicitudes">
          {{ $t('report.label.table.totalRequests') }}:
          {{ ListConfirmMonetization?.reports?.length || 0 }}
        </p>
      </div>

      <v-dialog
        v-model="dialogMonetization"
        transition="dialog-bottom-transition"
        max-width="600"
        persistent
      >
        <template>
          <v-card class="container justify-content-between align-items-center">
            <button class="close-button" @click="closeDialog()">
              <span class="small-x">X</span>
            </button>
            <v-col cols="12" md="12" sm="12">
              <img
                src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png"
                class="custom-img"
              />
            </v-col>
            <h2 class="custom-title">{{ $t('report.label.confirmMonetization') }}</h2>
            <p class="custom-text" style="text-align: center">
              {{ $t('report.label.confirmMonetization.text') }}
            </p>
            <v-form ref="form" class="pr-5 pl-5">
              <v-file-input
                v-model="fileModel"
                :label="$t('label.uploadFileExcel')"
                accept=".xls,.xlsx"
                show-size
                outlined
                counter
                @change="handleFileUpload"
              ></v-file-input>
            </v-form>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                x-medium
                large
                rounded
                color="primary"
                :disabled="!isFormValid"
                @click="postConfirm()"
              >
                {{ $t('button.send') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

import {
  REPORTS_M,
  ACTION_GET_LIST_CONFIRM_MONETIZATION,
  ACTION_CONFIRM_MONETIZATIONS,
  ACTION_GET_CONFIRM_MONETIZATION_JOB_STATUS,
  GET_LIST_CONFIRM_MONETIZATION,
  GET_LOADING_MONETIZATIONS,
  GET_JOB_STATUS,
} from "@/views/reports/store/types/types.js";

import { mapActions, mapGetters } from "vuex";
import i18n from '@/plugins/i18n';

export default {
  name: "detailReportComponent",
  props: {
    report: {
      required: true,
    },
  },

  data() {
    return {
      searchTerm: "",
      fileModel: null,
      monetizationReportId: 0,
      isFormValid: null,
      dialogMonetization: false,
      processingJob: false,
      jobId: null,
      pollingInterval: null,
    };
  },

  async mounted() {
    this.getListConfirmMonetization();
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('report.label.table.codeConfirmation'),
          value: "monetizationReportId",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('report.label.table.startDate'),
          value: "startDate",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1 my-custom-font",
        },
        {
          text: this.$t('report.label.table.requestCount'),
          value: "requestCount",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('report.label.table.requestStatus'),
          value: "requestStatus",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          value: "action",
          sortable: false,
          align: "center",
          //class: "custom-header mdi-pencil text-subtitle-1",
        },
      ];
    },
    ...mapGetters({
      ListConfirmMonetization: `${REPORTS_M}${GET_LIST_CONFIRM_MONETIZATION}`,
      loading: `${REPORTS_M}${GET_LOADING_MONETIZATIONS}`,
      jobStatus: `${REPORTS_M}${GET_JOB_STATUS}`,
    }),
  },

  methods: {
    search() {
      // Actualiza el término de búsqueda
      this.searchTerm = event.target.value;
    },

    modelConfirmMonetization(monetizationReportId) {
      this.selectedFile = null;
      this.isFormValid = false; // Reiniciar validación del formulario

      // Resetear el input de archivo
      this.fileModel = null;

      this.dialogMonetization = true;
      this.monetizationReportId = monetizationReportId;
    },

    closeDialog() {
      this.selectedFile = null;
      this.isFormValid = false; // Reiniciar validación del formulario

      // Resetear el input de archivo
      this.fileModel = null;

      this.dialogMonetization = false;
    },

    handleFileUpload(file) {
      if (file) {
        this.isFormValid = true;
      } else {
        this.isFormValid = false;
      }

      const allowedTypes = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      ];

      if (!allowedTypes.includes(file.type)) {
        Swal.fire({
          icon: "error",
          title: i18n.t('label.formatExcel.invalid.title'),
          text: i18n.t('label.formatExcel.invalid.text')
        });
        return;
      }
      this.selectedFile = file;
    },

    async postConfirm() {
      const formdata = new FormData();
      formdata.append(
        "monetizationReportId",
        parseInt(this.monetizationReportId)
      );
      formdata.append("fileReport", this.selectedFile);
      const monetization = await this.postConfirmMonetization(formdata);
      this.selectedFile = null;
      
      // Si es 202, hay un job en proceso - iniciar polling
      if (monetization.status === 202 && monetization.jobId) {
        this.jobId = monetization.jobId;
        this.processingJob = true;
        
        Swal.fire({
          title: i18n.t('report.label.processing.title') || 'Procesando...',
          text: i18n.t('report.label.processing.text') || 'Por favor espera mientras se genera el archivo.',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
        
        this.startPolling();
        return;
      }
      
      // Procesar respuesta normal
      if (monetization) {
        if(monetization.data.payload.stateResponse){
          await Swal.fire({
            text: monetization.data.payload.message,
            icon: "success",
            confirmButtonText: i18n.t('button.ok')
          });
        } else {
          await Swal.fire({
            text: monetization.data.payload.message,
            icon: "error",
            confirmButtonText: i18n.t('button.ok')
          });
        }

        await this.getListConfirmMonetization();
        
        this.isFormValid = false;
        this.dialogMonetization = false;
      }
    },

    startPolling() {
      // Polling cada 3 segundos
      this.pollingInterval = setInterval(async () => {
        try {
          await this.getConfirmMonetizationJobStatus(this.jobId);
          
          if (!this.jobStatus) return;
          
          // JobStatus: 0 = Pendiente, 1 = Procesando, 2 = Completado, 3 = Error
          if (this.jobStatus.jobStatus === 2) {
            // Job completado
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
            this.processingJob = false;
            
            Swal.close();
            
            await Swal.fire({
              text: this.jobStatus.message || i18n.t('report.label.confirm.success') || 'Confirmación procesada exitosamente',
              icon: "success",
              confirmButtonText: i18n.t('button.ok'),
            });
            
            await this.getListConfirmMonetization();
            
            this.isFormValid = false;
            this.dialogMonetization = false;
          } else if (this.jobStatus.jobStatus === 3) {
            // Job falló
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
            this.processingJob = false;
            
            Swal.close();
            
            await Swal.fire({
              title: i18n.t('report.label.error.title') || 'Error',
              text: this.jobStatus.errorMessage || i18n.t('report.label.processing.error') || 'Error al procesar la confirmación',
              icon: "error",
              confirmButtonText: i18n.t('button.ok'),
            });
            
            this.isFormValid = false;
            this.dialogMonetization = false;
          }
          // Si es 0 o 1, seguir esperando (no hacer nada)
        } catch (error) {
          console.error('Error en polling:', error);
          clearInterval(this.pollingInterval);
          this.pollingInterval = null;
          this.processingJob = false;
          
          Swal.close();
          
          await Swal.fire({
            title: i18n.t('report.label.error.title') || 'Error',
            text: i18n.t('report.label.polling.error') || 'Error al consultar el estado del proceso',
            icon: "error",
            confirmButtonText: i18n.t('button.ok'),
          });
          
          this.isFormValid = false;
          this.dialogMonetization = false;
        }
      }, 3000); // Cada 3 segundos
    },

    redirectToDownload(link) {
      window.open(link, "_blank");
    },

    ...mapActions({
      getListConfirmMonetization: `${REPORTS_M}${ACTION_GET_LIST_CONFIRM_MONETIZATION}`,
      postConfirmMonetization: `${REPORTS_M}${ACTION_CONFIRM_MONETIZATIONS}`,
      getConfirmMonetizationJobStatus: `${REPORTS_M}${ACTION_GET_CONFIRM_MONETIZATION_JOB_STATUS}`,
    }),
  },
};
</script>

<style lang="css" scoped>
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Amsi Pro", sans-serif;
  color: #2d0049;
  font-weight: normal;
}

.headerReport {
  display: flex;
  gap: 40px;
  flex-direction: column;
  margin: 40px 0 40px;
}

.custom-font {
  font-size: 20px;
}

.totalSolicitudesContainer {
  position: fixed;
  bottom: 5px;
}

.totalSolicitudes {
  font-weight: bold;
  color: #6e17a5;
  font-size: 23px;
}

.actions {
  display: inline-flex;
}

.container {
  position: relative;
}

.custom-img {
  width: 170px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.custom-title {
  color: #6e17a5;
  justify-items: center;
  text-align: center;
  font-size: 33px;
  font-weight: bolder;
  margin-bottom: 7px;
}

.custom-text {
  color: #6e17a5;
  justify-items: center;
  text-align: center;
  font-size: 20px;
  margin-bottom: 25px;
}

.small-x {
  font-size: x-large;
  color: #6e17a5;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
}

/*Resposive*/

@media screen and (max-width: 768px) {
  .formReport {
    display: flex;
    gap: 40px;
    flex-direction: column;
    justify-content: center;
  }
}

@media screen and (max-width: 550px) {
  .headerReport {
    margin: 40px 10px;
  }
}

@media screen and (max-width: 425px) {
  .formReport {
    display: flex;
    gap: 50px;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
